<template>
    <span>{{convertDate}}</span>
</template>

<script>
    export default {
        name: 'DateColumn',
        props: {
            date: {
                type: String,
                required: true
            }
        },
        computed: {
            convertDate() {
                let options = {year: 'numeric', month: 'short', day: 'numeric', hour12: false, hour: 'numeric', minute: 'numeric'}
                let dateObject = new Date(this.date)
                return dateObject.toLocaleString('en-us', options)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/DateColumn.vue